function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1396:357)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.84437 1.3175L1.31738 7.90481L7.90468 8.56354",
  className: "color-stroke",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.58105 7.90481C3.4255 5.40163 6.32391 3.82068 9.61756 3.82068C15.0192 3.82068 19.4985 8.30004 19.4985 13.7016C19.4985 19.1032 15.0192 23.5826 9.61756 23.5826C6.32391 23.5826 3.4255 22.0016 1.58105 19.4985",
  className: "color-stroke",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1396:357"
}, /*#__PURE__*/React.createElement("rect", {
  width: 20.6841,
  height: 24.9,
  className: "color-fill"
})));
function SvgRetake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetake);
export default __webpack_public_path__ + "static/media/retake.d7bb95eb8c91314e2dc9aba1c0e264d5.svg";
export { ForwardRef as ReactComponent };